<template>
  <svg width="2em" height="2em" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path d="M1 2.05112L8.0279 0L15.0488 2.05112V6.25717C15.0487 8.41276 14.3704 10.5137 13.1099 12.2623C11.8494 14.0109 10.0706 15.3186 8.02556 16C5.97989 15.3187 4.2005 14.0108 2.93955 12.2618C1.6786 10.5128 1.00003 8.41137 1 6.25522V2.05112Z" fill="currentColor"/>
    </g>
  </svg>
</template>
